var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head-text"},[_c('div',{staticClass:"head-title"},[_c('div',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('van-divider',{staticClass:"line"})],1),_vm._t("search")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }